import { IndianRupee } from 'lucide-react';
import * as React from 'react';
import { Card, CardContent } from '../ui/card';
import { CustomAlertDialog } from '../AlertDialog';

import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import { useDelBenefitCategoryMutation } from '@/store/benefitCategoryApi';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';

interface Ledger {
  ledger: string;
  _id: string;
}

interface Benefit {
  ledger: Ledger;
  remark?: string;
  amount: number;
  date: string;
  month: string;
  year: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  __v: number;
}

export default function BenefitCategories({
  allLedger,
  allBenefits,
}: {
  allLedger: Ledger[];
  allBenefits: Benefit[];
}) {
  const { user } = useSelector((state: RootState) => state.user);
  const [deleteCategory] = useDelBenefitCategoryMutation();

  const benefitCategories = allLedger?.map((ledger: Ledger) => {
    return {
      _id: ledger._id,
      name: ledger.ledger,
      amount: allBenefits?.reduce((acc: number, benefit: Benefit) => {
        if (benefit.ledger?._id === ledger?._id) {
          acc += benefit.amount;
        }
        return acc;
      }, 0),
      icon: IndianRupee,
    };
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {benefitCategories?.map((category, index) => (
        <Card
          key={index}
          className="hover:shadow-lg transition-all duration-300 cursor-pointer border-l-4 border-l-emerald-500 hover:-translate-y-1"
        >
          <Link to={`${category.name}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-gray-600 mb-1 text-sm font-medium">{category.name}</p>
                  <h3 className="text-2xl font-bold text-emerald-600">₹{category.amount?.toLocaleString('en-IN')}</h3>
                  <div className="flex items-center mt-2">
                    <CustomAlertDialog
                      title="Delete Category"
                      description={
                        <>
                          Are you sure you want to delete the category
                          <span className="font-semibold text-emerald-600">
                            {' '}
                            "{category.name}"{' '}
                          </span>
                          with an accumulated amount of
                          <span className="font-semibold text-emerald-600">
                            {' '}
                            ₹{category.amount?.toLocaleString('en-IN')}{' '}
                          </span>
                          ? <br /> <br /> *The category will be deleted, but the transactions will remain.
                        </>
                      }
                      onConfirm={() => {
                        deleteCategory({
                          Id: category._id,
                          Token: user?.token,
                        });
                      }}
                      triggerButton={
                        <button className="text-xs text-red-500 hover:underline mt-1 font-medium">
                          Delete Category
                        </button>
                      }
                    />
                  </div>
                </div>
                <div className="w-12 h-12 bg-emerald-100 dark:bg-emerald-950 rounded-full flex items-center justify-center">
                  <category.icon className="w-6 h-6 text-emerald-600" />
                </div>
              </div>
            </CardContent>
          </Link>
        </Card>
      ))}
    </div>
  );
}
